module.exports = __webpack_public_path__ + "media/components/assets/icons/comment_success-65d5fdfe75e257f6dedaf270a7db800b.svg";